import React, { useContext, useMemo } from 'react';
import { Card, Col, Divider, Empty, notification, Row, Typography } from 'antd';
import { SessaoARContext } from '../../Contexts/SessaoContext';
import { EnumTipoUsuario } from '../../../Models/Domain/AreaRestrita/Sessao';

import { ParametrosDaSessaoARContext, ParametrosDaSessaoDaEscola } from '../../Views/Sistema/ParametrosDaSessao';
import { PropriedadesDeNotificacao } from '../../../Utils/Notificacoes';
import { CadastroDeEscola } from '../../../Views/Cadastros/Escola/Componentes/CadastroDeEscola';
import { TypeEscola } from '../../../Models/Domain/Pessoa/Escola';

const DadosCadastraisParaTipoEscola: React.FC<{
}> = (props) => {

    const SessaoAR = useContext(SessaoARContext);
    const ParametrosDaSessaoAR = useContext(ParametrosDaSessaoARContext) as ParametrosDaSessaoDaEscola;

    const informacoesDaEscola: TypeEscola | undefined = useMemo(() => { return SessaoAR?.sessao?.info }, [])

    if (
        SessaoAR?.sessao?.tipoDeUsuario !== EnumTipoUsuario.Escola ||
        ParametrosDaSessaoAR.tipoDeUsuario !== EnumTipoUsuario.Escola
    ) return <Empty description="A sessão atual não corresponde a uma sessão do tipo escola"/>;

    return (
        <Row style={{height: "100%"}} gutter={[16, 0]}>
            <Col xs={24}>
                <Card style={{ height: "100%" }}>
                    {
                        informacoesDaEscola == undefined ?
                            <Empty description="Ocorreu um erro inesperado" /> :
                            <React.Fragment>
                                <Typography.Title level={4} style={{ marginTop: 0 }}>
                                    {informacoesDaEscola.pessoa?.nome}
                                    <Divider />
                                </Typography.Title>

                                <CadastroDeEscola
                                    escolaEmAlteracao={informacoesDaEscola}
                                    privilegio='escola'
                                    exibirNotificacaoAoFinalizar={false}

                                    depoisDeFinalizar={() => {
                                        const intervaloSeg = 2;
                                        let mensagem: JSX.Element = <> Informações atualizadas com sucesso. </>

                                        notification.open({
                                            ...PropriedadesDeNotificacao.Sucesso(mensagem),
                                            duration: intervaloSeg
                                        })

                                        setTimeout(() => {
                                            window.location.reload()
                                        }, intervaloSeg * 1000)
                                    }}
                                />

                            </React.Fragment>
                    }
                </Card>
            </Col>
        </Row>
    );
}

export default DadosCadastraisParaTipoEscola;